import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const ShipmentTagsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipment tags",
    cell: (row) => {
      const tags = row.tags?.map((tag) => tag.name) ?? [];
      return tags.join(", ");
    },
  };
